import { judgeAcmg } from '@/@core/layouts/utils'
import {
  chromosomeRegion,
  formatDate,
  formatVariantInheritance
} from '@/@core/utils/utils'
import { judgeStrength } from '@/views/analyze/ACMG'
import { ACMG_evidences_zh, MT_Site_Detail } from '../CurrentRepoet'

export const template6And7 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  isRoh: any,
  samples: any[],
  userAcmgData: any[],
  affected_child_clinicalInformation: any,
  currentRohList: any[],
  sanger: any[],
  chromosomeData: any[],
  detectionRawDataVariationList: any[],
  detectionMTVariationList: any[],
  strRang: any[],
  i18n: any,
  isACMGSF: any,
  t: any
) => {
  return [
    {
      type: 'block-sx-title',
      children: [
        {
          type: 'span',
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2-genetic',
      children: [
        {
          text: '受检者全基因组测序基因检测报告'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '样本信息'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '样本编号'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '姓名'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '性别'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '年龄'
                    }
                  ]
                }
              ]
            },
            samples.length > 1
              ? {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '与受检者关系'
                        }
                      ]
                    }
                  ]
                }
              : {
                  type: 'display-none',
                  children: [
                    {
                      text: ''
                    }
                  ]
                },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '样本类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '送检医院'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '送检科室/医生'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '送检日期'
                    }
                  ]
                }
              ]
            }
          ].map((i) => i)
        },
        ...samples.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.name}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.patient?.patientName ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${t((row?.patient?.gender as string) ?? '-')}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${
                          row.patient?.dateOfBirth
                            ? (Math.floor(
                                (new Date().valueOf() -
                                  new Date(
                                    row.patient?.dateOfBirth
                                  ).valueOf()) /
                                  3.15576e10
                              ) <= 0
                                ? 0
                                : Math.floor(
                                    (new Date().valueOf() -
                                      new Date(
                                        row.patient?.dateOfBirth
                                      ).valueOf()) /
                                      3.15576e10
                                  )) + '岁'
                            : '-'
                        }`
                      }
                    ]
                  }
                ]
              },
              samples.length > 1
                ? {
                    type: 'table-cell',
                    children: [
                      {
                        type: 'p3-center',
                        children: [
                          {
                            text: t(row.sample?.type ?? '-')
                          }
                        ]
                      }
                    ]
                  }
                : {
                    type: 'display-none',
                    children: [
                      {
                        text: ''
                      }
                    ]
                  },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row?.sample?.vcfType?.toLocaleUpperCase()}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row?.patient?.infirmaryName ?? ''}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row?.patient?.departmentName ?? '-'}/${
                          row.patient?.physicianName ?? '-'
                        }`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${formatDate(row.patient?.arrivalDate) ?? '-'}`
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }),
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  text: `临床表型：${affected_child_clinicalInformation ?? '-'}`
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '分析结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  text: `通过对疾病相关基因的测序分析，发现与疾病表型相关的高度可疑变异。`
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },

    isRoh && currentRohList.length
      ? {
          type: 'table-available',
          children: [
            {
              type: 'table-available',
              children: [
                {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell-c9',
                      children: [
                        {
                          type: 'p3-center-bold',
                          children: [
                            {
                              text: '杂合性缺失(LOH)变异(>5M)'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell-c9',
                      children: [
                        {
                          text: `本次检测，在受检者中检出第${currentRohList[0].chrom}号染色体(${currentRohList[0].begin}:${currentRohList[0].end})位置存在片段纯合。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      : {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        },

    reportsVariants.filter((row) => row.pos).filter((row) => row.chrom === 'MT')
      .length
      ? {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '线粒体检测结果'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '样本'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: 'HGVS变异'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '变异比例'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          type: 'p3-center-bold',
                          children: [
                            {
                              text: '线粒体相关'
                            }
                          ]
                        },
                        {
                          type: 'p3-center-bold',
                          children: [
                            {
                              text: '数据库中的频率(%)'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '变异评级'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '疾病'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '变异来源'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            ...reportsVariants
              .filter((row) => row.pos)
              .filter((row) => row.chrom === 'MT')
              .map((row) => {
                return {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: '受检者'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `m.${row.pos}${row.nuc_change}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${
                                row.allele_frequency &&
                                row.allele_frequency !== '.'
                                  ? (row.allele_frequency * 100).toFixed(2)
                                  : ''
                              }%`
                            }
                          ]
                        },
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `(${row.coverage})`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${row.gene ?? '-'}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${row.gnomAD_exome_ALL}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: row.user_acmg_classification
                                ? row.user_acmg_classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.ACMG_classification
                                ? row.ACMG_classification?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.classification
                                ? row.classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              type: 'p3-center-max',
                              children: [
                                {
                                  text: row.OMIMCN ? row.OMIMCN : ''
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              type: 'p3-center-max',
                              children: [
                                {
                                  text:
                                    row.mom_id && row.mom_id !== '.'
                                      ? '母亲'
                                      : row.allele_frequency &&
                                        row.allele_frequency !== '.' &&
                                        row.mom_id
                                      ? '自发'
                                      : '未知'
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              }),
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      : {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        },
    !reportsVariants
      .filter((row) => row.pos)
      .filter((row) => row.chrom === 'MT').length
      ? {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        }
      : {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '检测说明'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3',
                      children: [
                        {
                          text: '一．线粒体结果'
                        }
                      ]
                    },
                    {
                      type: 'p7',
                      children: [
                        {
                          text: `根据ACMG指南，${reportsVariants
                            .filter((row) => row.chrom === 'MT')
                            .filter(
                              (row) => row.pos && row.c_nomen && row.p_nomen
                            )
                            .map(
                              (row) =>
                                `提示${row.gene}基因的突变(m.${row.pos}${
                                  row.nuc_change
                                })为${judgeAcmg(
                                  row.user_acmg_classification
                                    ? row.user_acmg_classification
                                    : row.ACMG_classification
                                    ? row.ACMG_classification
                                    : row.classification
                                    ? row.classification
                                    : ''
                                )}`
                            )
                            .join('，')}`
                        }
                      ]
                    },

                    ...reportsVariants
                      .filter((row) => row.chrom === 'MT')
                      .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                      .map((row, index) => {
                        return {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'p7',
                                  children: [
                                    {
                                      type: 'span-red',
                                      text: `${index + 1}）基因${row.gene} m.${
                                        row.pos
                                      }${row.nuc_change}变异：${judgeAcmg(
                                        row.user_acmg_classification
                                          ? row.user_acmg_classification
                                          : row.ACMG_classification
                                          ? row.ACMG_classification
                                          : row.classification
                                      )}${
                                        row.acmg_evidences
                                          ? `（${row.acmg_evidences?.join(
                                              ','
                                            )}）`
                                          : ''
                                      }`
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              type: 'p7',
                              children: row.acmg_evidences?.length
                                ? row.acmg_evidences?.map((item: any) => {
                                    const first = item.split('_')[0]
                                    let text = ACMG_evidences_zh[first]

                                    const temp = userAcmgData.find(
                                      (log) =>
                                        log.variantKey ===
                                          `${row.gene}-${row.c_nomen}-${row.transcript}` &&
                                        `${first}${
                                          judgeStrength(item)
                                            ? `-${judgeStrength(item)}`
                                            : ''
                                        }` === log.acmgCriteria
                                    )

                                    if (first === 'PM2') {
                                      text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                    }

                                    return {
                                      type: 'p7',
                                      children: [
                                        {
                                          text: `${item}:${
                                            temp ? temp?.evidenceDetails : text
                                          }`
                                        }
                                      ]
                                    }
                                  })
                                : [
                                    {
                                      type: 'display-none',
                                      children: [
                                        {
                                          text: ``
                                        }
                                      ]
                                    }
                                  ]
                            },
                            {
                              type: 'p7',
                              children: [
                                {
                                  text: `疾病介绍：`
                                }
                              ]
                            },
                            {
                              type: 'p7',
                              children: [
                                {
                                  text:
                                    row.MitoMap && row.MitoMap.disease_ch
                                      ? `${row.MitoMap.disease_ch}`
                                      : '暂无结果'
                                }
                              ]
                            },
                            {
                              type: 'p7',
                              children: [
                                {
                                  text:
                                    row.MitoMap && row.MitoMap.info
                                      ? // eslint-disable-next-line no-useless-escape
                                        `${row.MitoMap.info}`
                                          // eslint-disable-next-line no-useless-escape
                                          .split(/。\s*(?=[^。]+\：)/g)
                                          .join('。\n\n')
                                      : '暂无结果'
                                }
                              ]
                            }
                          ]
                        }
                      }),
                    {
                      type: 'p7',
                      children: [
                        {
                          text: `以上结果请结合家系和临床进一步分析。`
                        }
                      ]
                    },
                    reportsVariants
                      .filter((row) => row.chrom === 'MT')
                      .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                      .map((row) => {
                        row.sanger = sanger.find(
                          (i) =>
                            i.keyId === row.keyId ||
                            row.keyId?.includes(i.keyId)
                        )?.base

                        return row
                      })
                      .filter((i) => i.sanger).length
                      ? {
                          type: 'p7-color-bold',
                          children: [
                            {
                              text: `SNV及InDel图`
                            }
                          ]
                        }
                      : {
                          type: 'p7-color-bold',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                    ...reportsVariants
                      .filter((row) => row.chrom === 'MT')
                      .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                      .map((row) => {
                        row.sanger = sanger.find(
                          (i) =>
                            i.keyId === row.keyId ||
                            row.keyId?.includes(i.keyId)
                        )?.base

                        return row
                      })
                      .filter((i) => i.sanger)
                      .map((row) => {
                        const name = reportValue?.patient?.patientName
                        const sampleType = t('Proband')

                        return {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              text: `${sampleType}-${name}-${row.gene};${row.transcript}(MANE):${row.c_nomen}(${row.p_nomen})。`
                            },
                            {
                              type: 'image',
                              children: [
                                {
                                  text: ``
                                }
                              ],
                              url: sanger.find(
                                (i) =>
                                  i.keyId === row.keyId ||
                                  row.keyId?.includes(i.keyId)
                              )?.base
                            }
                          ]
                        }
                      })
                  ]
                }
              ]
            }
          ]
        },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '临床表型高度相关，且致病性证据较为充分的点突变(SNVs)或大片段缺失重复(CNVs)'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'HGVS'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '突变类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '变异评级'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 疾病及遗传方式'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 变异来源'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .filter((row) => row.pos)
          .filter((row) => row.chrom !== 'MT')
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.gene ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `chr${row.chrom}:${row.pos}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.exon === '.' ? '' : `(${row.exon})`}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.transcript}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.c_nomen}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.coding_effect ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text:
                            row.chrom === 'MT'
                              ? `${row.coverage}[${row.allele_frequency}]`
                              : row.allele_frequency
                              ? row.allele_frequency < 0.85
                                ? t('heterozygote')
                                : t('homozygote')
                              : '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? row.user_acmg_classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.ACMG_classification
                            ? row.ACMG_classification?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text: row.OMIMCN ? row.OMIMCN : ''
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text:
                                row.mom_id &&
                                row.mom_id !== '.' &&
                                row.dad_id &&
                                row.dad_id !== '.'
                                  ? '父母'
                                  : row.mom_id && row.mom_id !== '.'
                                  ? '母亲'
                                  : row.dad_id && row.dad_id !== '.'
                                  ? '父亲'
                                  : row.allele_frequency &&
                                    row.allele_frequency !== '.' &&
                                    row.dad_id
                                  ? '自发'
                                  : row.allele_frequency &&
                                    row.allele_frequency !== '.' &&
                                    !row.dad_id
                                  ? '未知'
                                  : '未知'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .filter((row) => row.pos)
          .filter((row) => row.chrom !== 'MT').length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '检测说明'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '一．SNV、InDel结果'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `根据ACMG指南，${reportsVariants
                        .filter((row) => row.chrom !== 'MT')
                        .filter((item) => item.variantsType === 'KeyFinding')
                        .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                        .map(
                          (row) =>
                            `提示${row.gene}基因${
                              row.c_nomen !== '.'
                                ? `${row.c_nomen}(${row.p_nomen})`
                                : ``
                            }的突变为${
                              row.user_acmg_classification
                                ? row.user_acmg_classification
                                : row.ACMG_classification
                                ? row.ACMG_classification
                                : row.classification
                            }`
                        )
                        .join('，')}`
                    }
                  ]
                },

                ...reportsVariants
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((item) => item.variantsType === 'KeyFinding')
                  .filter((row) => row.chrom !== 'MT')
                  .map((row, index) => {
                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'span-red',
                                  text: `${index + 1}）基因${row.gene}${
                                    row.chrom !== '.'
                                      ? `:${row.c_nomen}(${row.p_nomen})变异`
                                      : ''
                                  }：${judgeAcmg(
                                    row.user_acmg_classification
                                      ? row.user_acmg_classification
                                      : row.ACMG_classification
                                      ? row.ACMG_classification
                                      : row.classification
                                  )}${
                                    row.acmg_evidences
                                      ? `（${row.acmg_evidences?.join(',')}）`
                                      : ''
                                  }`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: row.acmg_evidences?.length
                            ? row.acmg_evidences?.map((item: any) => {
                                const first = item.split('_')[0]
                                let text = ACMG_evidences_zh[first]

                                const temp = userAcmgData.find(
                                  (log) =>
                                    log.variantKey ===
                                      `${row.gene}-${row.c_nomen}-${row.transcript}` &&
                                    `${first}${
                                      judgeStrength(item)
                                        ? `-${judgeStrength(item)}`
                                        : ''
                                    }` === log.acmgCriteria
                                )

                                if (first === 'PM2') {
                                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                }

                                return {
                                  type: 'p7',
                                  children: [
                                    {
                                      text: `${item}:${
                                        temp ? temp?.evidenceDetails : text
                                      }`
                                    }
                                  ]
                                }
                              })
                            : [
                                {
                                  type: 'display-none',
                                  children: [
                                    {
                                      text: ``
                                    }
                                  ]
                                }
                              ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病临床描述`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `基因：${row.gene}`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病:`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p5-genetic-value',
                          children:
                            row.newOMIMData && row.newOMIMData.length
                              ? row.newOMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.disease_description_cn
                                      ? i.disease_description_cn
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.phenotype ? i.phenotype : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.disease ?? '-'
                                                };${i.genetic_mode ?? '-'}`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.OMIMData && row.OMIMData.length
                              ? row.OMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.phenoDescriptionCNStr
                                      ? i.phenoDescriptionCNStr
                                          .join('\n')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.clinicalSynopsis_zh
                                      ? i.clinicalSynopsis_zh
                                          .join(';')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalFeaturesCNText = `<span style="font-weight: 600;">临床表现相关文献：</span>\n${
                                    i.phenoClinicalFeaturesCNStr
                                      ? i.phenoClinicalFeaturesCNStr.join('\n')
                                      : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText
                                  const ClinicalFeaturesHighlightedText =
                                    higlitghtStr
                                      ? phenoClinicalFeaturesCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoClinicalFeaturesCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.pheno_name_cn ?? '-'
                                                }(OMIM:${i.phenoMim});${
                                                  i.inheritance ?? '-'
                                                }`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalFeaturesHighlightedText
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.MitoMap && row.MitoMap.disease_ch
                              ? [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'h3',
                                            text: `${
                                              row?.MitoMap?.disease_ch ?? '-'
                                            }`
                                          }
                                        ]
                                      },
                                      {
                                        type: 'paragraph',
                                        text: `${
                                          row?.MitoMap?.info ?? t('No Results')
                                        }`
                                      }
                                    ]
                                  }
                                ]
                              : [
                                  {
                                    text: ''
                                  }
                                ]
                        }
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: `以上结果请结合家系和临床进一步分析。`
                    }
                  ]
                },
                reportsVariants
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((item) => item.variantsType === 'KeyFinding')
                  .filter((row) => row.chrom !== 'MT')
                  .map((row) => {
                    row.sanger = sanger.find(
                      (i) =>
                        i.keyId === row.keyId || row.keyId?.includes(i.keyId)
                    )?.base

                    return row
                  })
                  .filter((i) => i.sanger).length
                  ? {
                      type: 'p7-color-bold',
                      children: [
                        {
                          text: `SNV及InDel图`
                        }
                      ]
                    }
                  : {
                      type: 'p7-color-bold',
                      children: [
                        {
                          text: ``
                        }
                      ]
                    },
                ...reportsVariants
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((item) => item.variantsType === 'KeyFinding')
                  .filter((row) => row.chrom !== 'MT')
                  .map((row) => {
                    row.sanger = sanger.find(
                      (i) =>
                        i.keyId === row.keyId || row.keyId?.includes(i.keyId)
                    )?.base

                    return row
                  })
                  .filter((i) => i.sanger)
                  .map((row) => {
                    const name = reportValue?.patient?.patientName
                    const sampleType = t('Proband')

                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'span-blod',
                          text: `${sampleType}-${name}-${row.gene};${row.transcript}(MANE):${row.c_nomen}(${row.p_nomen})。`
                        },
                        {
                          type: 'image',
                          children: [
                            {
                              text: ``
                            }
                          ],
                          url: sanger.find(
                            (i) =>
                              i.keyId === row.keyId ||
                              row.keyId?.includes(i.keyId)
                          )?.base
                        }
                      ]
                    }
                  })
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'CNV检测结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'Cytoband'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '大小'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'CNV类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '评级'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '疾病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '变异来源'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((row) => row.SV_start)
          .filter((row) => !row.left_genes)
          .map((row) => {
            console.log(
              'chromosomeRegion',
              row.chrom,
              row.SV_start,
              row.SV_end,
              chromosomeData,
              chromosomeData.filter((item) => item['#chrom'] == row.chrom),
              chromosomeRegion(
                row.chrom,
                row.SV_start,
                row.SV_end,
                chromosomeData.filter((item) => item['#chrom'] == row.chrom)
              )
            )

            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text:
                            row.chrom && row.SV_start
                              ? `${row.chrom}:${row.SV_start}-${row.SV_end}`
                              : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text:
                            chromosomeData && chromosomeData.length
                              ? chromosomeRegion(
                                  row.chrom,
                                  row.SV_start,
                                  row.SV_end,
                                  chromosomeData.filter(
                                    (item) => item['#chrom'] == row.chrom
                                  )
                                )
                              : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${
                            row.LEN ? (row.LEN / 1024).toFixed(0) : ''
                          }Kb`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.SV_type
                            ? row.SV_type.toLocaleUpperCase() === 'DEL'
                              ? 'DEL （缺失）'
                              : 'DUP （重复）'
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-max',
                      children: [
                        {
                          text: row.inheritance
                            ? row.inheritance
                            : row.omim_info
                            ? row.omim_info
                                .filter(
                                  (i: any) =>
                                    i.inheritance && i.inheritance !== '.'
                                )
                                .map(
                                  (i: any) =>
                                    `${i.inheritance}-${i.pheno_name_cn}`
                                )
                                .join(';')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-max',
                      children: [
                        {
                          text: `${row.gene_info?.omim_disease_genes
                            .map((item: any) => item.symbol)
                            .join(';')}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: ''
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((row) => row.SV_start)
          .filter((row) => !row.left_genes).length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                }
              ]
            }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },

    !reportsVariants
      .filter((row) => row.SV_start)
      .filter((row) => !row.left_genes).length
      ? {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        }
      : {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '检测说明'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3',
                      children: [
                        {
                          text: '一．CNV结果'
                        }
                      ]
                    },
                    ...reportsVariants
                      .filter((row) => row.SV_start)
                      .filter((row) => !row.left_genes)
                      .map((row) => {
                        return {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  text: `样本检出${
                                    row ? row.chrom : '**'
                                  }号染色体${
                                    row ? `${row.SV_start}:${row.SV_end}` : '**'
                                  }区域约${
                                    row ? (row.LEN / 1024).toFixed(0) : '**'
                                  }Kb的${
                                    row && row.SV_type
                                      ? row.SV_type.toLocaleUpperCase() ===
                                        'DEL'
                                        ? 'DEL （缺失）'
                                        : 'DUP （重复）'
                                      : ''
                                  }（拷贝数${
                                    row ? row.CN : '**'
                                  }），按照ACMG指南，该CNV的致病性评级为${
                                    row ? row.ccnv_classification : '**'
                                  }。涉及${
                                    row
                                      ? row.gene_info?.omim_disease_genes
                                          ?.length
                                      : '**'
                                  }个RefSeq蛋白编码基因。致病证据:${
                                    row.AnnotSV_evidences
                                  }(annotsv证据).`
                                }
                              ]
                            },
                            {
                              type: 'HighlightText',
                              children: [
                                {
                                  text: `${
                                    row.ScipCnvDescription &&
                                    row.ScipCnvDescription.positiveInfo &&
                                    row.ScipCnvDescription.positiveInfo.length
                                      ? row.ScipCnvDescription.positiveInfo
                                          .map((i: any) =>
                                            i18n.language === 'zh' ? i.zh : i.en
                                          )
                                          .join(';')
                                      : ''
                                  }`
                                }
                              ]
                            },

                            ...row.OMIMFlat.map((i: any) => {
                              return {
                                type: 'p7',
                                children: [
                                  {
                                    text: `${
                                      i?.pheno_name_cn
                                    }是一种常染色体显性遗传（${
                                      i?.inheritance
                                    }）疾病，患者常见临床表征有:${i.phenoDescriptionCN
                                      ?.map((item: any) => {
                                        const temp = item
                                          .filter(
                                            (i: any) =>
                                              i && i.text && i.text !== '.'
                                          )
                                          .map(
                                            (i: any) =>
                                              `${i.text}${
                                                i.value && i.value !== '.'
                                                  ? `(${i.value})`
                                                  : ''
                                              }`
                                          )
                                          .join()

                                        return temp
                                      })
                                      .join(',')
                                      .replace(/\s+/g, '')
                                      .replace(/\(.*?\)/g, '')
                                      .replace(/,+\)/g, '')
                                      .replace(/,综述+\)/g, '')}`
                                  }
                                ]
                              }
                            })
                          ]
                        }
                      })
                  ]
                }
              ]
            }
          ]
        },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '其他可疑变异：以下其他可疑变异临床意义尚不明确，需进一步研究，以明确其与受检者临床表型的相关性。由临床医生根据受检者的临床表型及家族史完成最终的诊断评估。'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'HGVS'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '突变类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '变异评级'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 疾病及遗传方式'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 变异来源'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((row) => row.pos)
          .filter(
            (item) =>
              item.variantsType === 'IncidentalDiscovery' ||
              item.variantsType === 'OtherDiscovery'
          )
          .filter((row) => row.chrom !== 'MT')
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.gene ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `chr${row.chrom}:${row.pos}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.exon === '.' ? '' : `(${row.exon})`}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.transcript}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.c_nomen}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.coding_effect ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text:
                            row.chrom === 'MT'
                              ? `${row.coverage}[${row.allele_frequency}]`
                              : row.allele_frequency
                              ? row.allele_frequency < 0.85
                                ? t('heterozygote')
                                : t('homozygote')
                              : '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? row.user_acmg_classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.ACMG_classification
                            ? row.ACMG_classification?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text: row.OMIMCN ? row.OMIMCN : ''
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text:
                                row.mom_id &&
                                row.mom_id !== '.' &&
                                row.dad_id &&
                                row.dad_id !== '.'
                                  ? '父母'
                                  : row.mom_id && row.mom_id !== '.'
                                  ? '母亲'
                                  : row.dad_id && row.dad_id !== '.'
                                  ? '父亲'
                                  : row.allele_frequency &&
                                    row.allele_frequency !== '.' &&
                                    row.dad_id
                                  ? '自发'
                                  : row.allele_frequency &&
                                    row.allele_frequency !== '.' &&
                                    !row.dad_id
                                  ? '未知'
                                  : '未知'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((row) => row.pos)
          .filter(
            (item) =>
              item.variantsType === 'IncidentalDiscovery' ||
              item.variantsType === 'OtherDiscovery'
          )
          .filter((row) => row.chrom !== 'MT').length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '检测说明'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '一．SNV、InDel结果'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `根据ACMG指南，${reportsVariants
                        .filter((row) => row.chrom !== 'MT')
                        .filter(
                          (item) =>
                            item.variantsType === 'IncidentalDiscovery' ||
                            item.variantsType === 'OtherDiscovery'
                        )
                        .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                        .map(
                          (row) =>
                            `提示${row.gene}基因${
                              row.c_nomen !== '.'
                                ? `${row.c_nomen}(${row.p_nomen})`
                                : ``
                            }的突变为${
                              row.user_acmg_classification
                                ? row.user_acmg_classification
                                : row.ACMG_classification
                                ? row.ACMG_classification
                                : row.classification
                            }`
                        )
                        .join('，')}`
                    }
                  ]
                },

                ...reportsVariants
                  .filter(
                    (item) =>
                      item.variantsType === 'IncidentalDiscovery' ||
                      item.variantsType === 'OtherDiscovery'
                  )
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((row) => row.chrom !== 'MT')
                  .map((row, index) => {
                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'span-red',
                                  text: `${index + 1}）基因${row.gene}${
                                    row.chrom !== '.'
                                      ? `:${row.c_nomen}(${row.p_nomen})变异`
                                      : ''
                                  }：${judgeAcmg(
                                    row.user_acmg_classification
                                      ? row.user_acmg_classification
                                      : row.ACMG_classification
                                      ? row.ACMG_classification
                                      : row.classification
                                  )}${
                                    row.acmg_evidences
                                      ? `（${row.acmg_evidences?.join(',')}）`
                                      : ''
                                  }`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: row.acmg_evidences?.length
                            ? row.acmg_evidences?.map((item: any) => {
                                const first = item.split('_')[0]
                                let text = ACMG_evidences_zh[first]

                                const temp = userAcmgData.find(
                                  (log) =>
                                    (log.variantId === row.AnnotSV_ID ||
                                      log.variantId === row._id) &&
                                    `${first}${
                                      judgeStrength(item)
                                        ? `-${judgeStrength(item)}`
                                        : ''
                                    }` === log.acmgCriteria
                                )

                                if (first === 'PM2') {
                                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                }

                                return {
                                  type: 'p7',
                                  children: [
                                    {
                                      text: `${item}:${
                                        temp ? temp?.evidenceDetails : text
                                      }`
                                    }
                                  ]
                                }
                              })
                            : [
                                {
                                  type: 'display-none',
                                  children: [
                                    {
                                      text: ``
                                    }
                                  ]
                                }
                              ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病临床描述`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `基因：${row.gene}`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病:`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p5-genetic-value',
                          children:
                            row.newOMIMData && row.newOMIMData.length
                              ? row.newOMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.disease_description_cn
                                      ? i.disease_description_cn
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.phenotype ? i.phenotype : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.disease ?? '-'
                                                };${i.genetic_mode ?? '-'}`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.OMIMData && row.OMIMData.length
                              ? row.OMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.phenoDescriptionCNStr
                                      ? i.phenoDescriptionCNStr
                                          .join('\n')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.clinicalSynopsis_zh
                                      ? i.clinicalSynopsis_zh
                                          .join(';')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalFeaturesCNText = `<span style="font-weight: 600;">临床表现相关文献：</span>\n${
                                    i.phenoClinicalFeaturesCNStr
                                      ? i.phenoClinicalFeaturesCNStr.join('\n')
                                      : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText
                                  const ClinicalFeaturesHighlightedText =
                                    higlitghtStr
                                      ? phenoClinicalFeaturesCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoClinicalFeaturesCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.pheno_name_cn ?? '-'
                                                }(OMIM:${i.phenoMim});${
                                                  i.inheritance ?? '-'
                                                }`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalFeaturesHighlightedText
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.MitoMap && row.MitoMap.disease_ch
                              ? [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'h3',
                                            text: `${
                                              row?.MitoMap?.disease_ch ?? '-'
                                            }`
                                          }
                                        ]
                                      },
                                      {
                                        type: 'paragraph',
                                        text: `${
                                          row?.MitoMap?.info ?? t('No Results')
                                        }`
                                      }
                                    ]
                                  }
                                ]
                              : [
                                  {
                                    text: ''
                                  }
                                ]
                        }
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: `以上结果请结合家系和临床进一步分析。`
                    }
                  ]
                },
                reportsVariants
                  .filter(
                    (item) =>
                      item.variantsType === 'IncidentalDiscovery' ||
                      item.variantsType === 'OtherDiscovery'
                  )
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((row) => row.chrom !== 'MT')
                  .map((row) => {
                    row.sanger = sanger.find(
                      (i) =>
                        i.keyId === row.keyId || row.keyId?.includes(i.keyId)
                    )?.base

                    return row
                  })
                  .filter((i) => i.sanger).length
                  ? {
                      type: 'p7-color-bold',
                      children: [
                        {
                          text: `SNV及InDel图`
                        }
                      ]
                    }
                  : {
                      type: 'p7-color-bold',
                      children: [
                        {
                          text: ``
                        }
                      ]
                    },
                ...reportsVariants
                  .filter(
                    (item) =>
                      item.variantsType === 'IncidentalDiscovery' ||
                      item.variantsType === 'OtherDiscovery'
                  )
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((row) => row.chrom !== 'MT')
                  .map((row) => {
                    row.sanger = sanger.find(
                      (i) =>
                        i.keyId === row.keyId || row.keyId?.includes(i.keyId)
                    )?.base

                    return row
                  })
                  .filter((i) => i.sanger)
                  .map((row) => {
                    const name = reportValue?.patient?.patientName
                    const sampleType = t('Proband')

                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'span-blod',
                          text: `${sampleType}-${name}-${row.gene};${row.transcript}(MANE):${row.c_nomen}(${row.p_nomen})。`
                        },
                        {
                          type: 'image',
                          children: [
                            {
                              text: ``
                            }
                          ],
                          url: sanger.find(
                            (i) =>
                              i.keyId === row.keyId ||
                              row.keyId?.includes(i.keyId)
                          )?.base
                        }
                      ]
                    }
                  })
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    isACMGSF
      ? {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: `其他变异：以下其他变异为ACMG SF v3.2 gene list中的97个二次发现基因检出变异结果`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '染色体位置'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因亚区'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: 'HGVS'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '突变类型'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因型'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '变异评级'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: ' 疾病及遗传方式'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            ...detectionRawDataVariationList
              .filter((row) => row.pos)
              .map((row) => {
                return {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: row.gene ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `chr${row.chrom}:${row.pos}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${row.var_location}`
                            }
                          ]
                        },
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${row.exon === '.' ? '' : `(${row.exon})`}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${row.transcript}`
                            }
                          ]
                        },
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: `${row.c_nomen}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: row.coding_effect ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text:
                                row.chrom === 'MT'
                                  ? `${row.coverage}[${row.allele_frequency}]`
                                  : row.allele_frequency
                                  ? row.allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              text: row.user_acmg_classification
                                ? row.user_acmg_classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.ACMG_classification
                                ? row.ACMG_classification?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.classification
                                ? row.classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              type: 'p3-center',
                              children: [
                                {
                                  text: ''
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              }),
            detectionRawDataVariationList.filter((row) => row.pos).length
              ? {
                  type: 'display-none',
                  children: [
                    {
                      text: ''
                    }
                  ]
                }
              : {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph-gene',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              type: 'paragraph',
                              children: [
                                {
                                  text: '-'
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
          ]
        }
      : {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'SV检测结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'Cytoband'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '大小'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'CNV类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '评级'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '疾病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '变异来源'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((row) => row.SV_start)
          .filter((row) => row.left_genes)
          .map((row) => {
            console.log(
              'chromosomeRegion',
              chromosomeRegion(
                row.chrom,
                row.SV_start,
                row.SV_end,
                chromosomeData.filter((item) => item['#chrom'] == row.chrom)
              )
            )

            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text:
                            row.chrom && row.SV_start
                              ? `${row.chrom}:${row.SV_start}:${row.SV_end}`
                              : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text:
                            chromosomeData && chromosomeData.length
                              ? chromosomeRegion(
                                  row.chrom,
                                  row.SV_start,
                                  row.SV_end,
                                  chromosomeData.filter(
                                    (item) => item['#chrom'] == row.chrom
                                  )
                                )
                              : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${
                            row.LEN ? (row.LEN / 1024).toFixed(0) : ''
                          }Kb`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.SV_type
                            ? row.SV_type.toLocaleUpperCase() === 'DEL'
                              ? 'DEL （缺失）'
                              : 'DUP （重复）'
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: row.inheritance
                            ? row.inheritance
                            : row.omim_info
                            ? row.omim_info
                                .filter(
                                  (i: any) =>
                                    i.inheritance && i.inheritance !== '.'
                                )
                                .map(
                                  (i: any) =>
                                    `${i.inheritance}-${i.pheno_name_cn}`
                                )
                                .join(';')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: `${row.gene_info?.omim_disease_genes
                            .map((item: any) => item.symbol)
                            .join(';')}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: ''
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((row) => row.SV_start)
          .filter((row) => row.left_genes).length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    !reportsVariants
      .filter((row) => row.SV_start)
      .filter((row) => row.left_genes).length
      ? {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        }
      : {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '检测说明'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3',
                      children: [
                        {
                          text: '一．SV结果'
                        }
                      ]
                    },
                    ...reportsVariants
                      .filter((row) => row.SV_start)
                      .filter((row) => row.left_genes)
                      .map((row) => {
                        return {
                          type: 'p7',
                          children: [
                            {
                              text: `样本检出${row ? row.chrom : '**'}号染色体${
                                row ? `${row.SV_start}:${row.SV_end}` : '**'
                              }区域约${
                                row ? (row.LEN / 1024).toFixed(0) : '**'
                              }Kb的${
                                row && row.SV_type
                                  ? row.SV_type.toLocaleUpperCase() === 'DEL'
                                    ? 'DEL （缺失）'
                                    : 'DUP （重复）'
                                  : ''
                              }（拷贝数${
                                row ? row.CN : '**'
                              }），按照ACMG指南，该CNV的致病性评级为${
                                row ? row.classification : '**'
                              }。涉及${
                                row
                                  ? row.gene_info?.omim_disease_genes?.length
                                  : '**'
                              }个RefSeq蛋白编码基因。`
                            }
                          ]
                        }
                      }),

                    ...reportsVariants
                      .filter((row) => row.SV_start)
                      .filter((row) => row.left_genes)
                      .map((row) => row.OMIMArr)
                      .flat()
                      .map((item: any) => item.omimData)
                      .flat()
                      .map((i) => {
                        const inheritances: string[] = []

                        if (
                          i &&
                          i.clinicalSynopsis &&
                          i.clinicalSynopsis.INHERITANCE &&
                          Array.isArray(i.clinicalSynopsis.INHERITANCE)
                        ) {
                          i.clinicalSynopsis.INHERITANCE.forEach(
                            (str: string) =>
                              inheritances.push(str.toLowerCase())
                          )
                          const inheritance = formatVariantInheritance(
                            Array.from([...new Set(inheritances)]).join(',')
                          )

                          const Inheritance =
                            inheritance || inheritance !== ''
                              ? inheritance
                              : Array.from([
                                  ...new Set(i.clinicalSynopsis.INHERITANCE)
                                ]).join(',')
                          i.inheritance = Inheritance
                        }

                        return {
                          ...i
                        }
                      })
                      .filter(
                        (item) => item.inheritance && item.inheritance !== '.'
                      )
                      .map((row) => {
                        return {
                          type: 'p7',
                          children: [
                            {
                              text: `${
                                row?.pheno_name_cn
                              }是一种常染色体显性遗传(${
                                row?.inheritance
                              })疾病，患者常见临床表征有:${row.phenoDescriptionCN
                                ?.map((item: any) => {
                                  const temp = item
                                    .filter(
                                      (i: any) => i && i.text && i.text !== '.'
                                    )
                                    .map(
                                      (i: any) =>
                                        `${i.text}${
                                          i.value && i.value !== '.'
                                            ? `(${i.value})`
                                            : ''
                                        }`
                                    )
                                    .join()

                                  return temp
                                })
                                .join(',')
                                .replace(/\s+/g, '')
                                .replace(/\(.*?\)/g, '')
                                .replace(/,+\)/g, '')
                                .replace(/,综述+\)/g, '')}`
                            }
                          ]
                        }
                      })
                  ]
                }
              ]
            }
          ]
        },
    {
      type: 'paragraph',
      text: ''
    },
    !reportsVariants
      .filter((row) => row.pos)
      .filter((row) => row.chrom === 'MT').length
      ? {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '线粒体检测结果'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '染色体位置'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因亚区'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: 'HGVS'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '突变类型'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '基因型'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '变异评级'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: ' 疾病及遗传方式'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-bold',
                      children: [
                        {
                          text: '变异来源'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      : {
          type: 'display-none',
          children: [
            {
              text: ''
            }
          ]
        },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'STR检测结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '重复序列'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'GangSTR结果'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'ExpansionHunter结果'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '参考范围'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '结论'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'OMIM'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((row) => row.GangSTR_repcn)
          .filter((row) => row.GangSTR_repci)
          .map((row) => {
            const temp = strRang.find((item) => item.gene == row.gene)

            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.gene ?? '-'}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `chr${row.chrom ?? '-'}:`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.start ?? '-'}:`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.end ?? '-'}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.RU ?? '-'}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.GangSTR_repcn ? `${row.GangSTR_repcn}` : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.EH_repcn ? row.EH_repcn : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: temp ? `n < ${temp.max}` : '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.STR_Result ? row.STR_Result : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-omim',
                      children: [
                        {
                          text: row.OMIMData
                            ? row.OMIMData.filter(
                                (i: any) =>
                                  i.inheritance && i.inheritance !== '.'
                              )
                                .map(
                                  (i: any) =>
                                    `${i.inheritance}-${i.pheno_name_cn}`
                                )
                                .join(';')
                            : ''
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((row) => row.GangSTR_repcn)
          .filter((row) => row.GangSTR_repci).length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'header4',
      children: [
        {
          text: '参考文献：'
        }
      ]
    },
    ...reportsVariants
      .filter((item) => item.VariantsArticles && item.VariantsArticles.length)
      .map((row, index) => {
        const VariantsArticles = row.VariantsArticles ?? ([] as any[])

        return VariantsArticles
      })
      .flat()
      .map((row, index) => {
        return {
          type: 'p7',
          children: [
            {
              text: `[${index + 1}] ${row.cite}`
            }
          ]
        }
      }),

    // {
    //   type: 'paragraph',
    //   text: ''
    // },
    // ...reportsVariants
    //   .filter((item) => item.OMIMData)
    //   .map((item) => item.OMIMData)
    //   .flat()
    //   .map((item) => {
    //     return {
    //       ...item,
    //       text: `${item.phenoClinicalFeaturesCNStr.join(
    //         '\n'
    //       )} ${item.phenoDescriptionCNStr.join('\n')}`
    //     }
    //   })
    //   .map((row, index) => {
    //     const ids = [...new Set([...extractIdsFromUrls(row.text)])]

    //     return {
    //       type: 'p7',
    //       children: [
    //         {
    //           text: `[${index + 1}]litvar数据库中已有文献报道与 ${
    //             row.pheno_name_cn
    //           }相关，PMID：${ids.join(';')}`
    //         }
    //       ]
    //     }
    //   }),
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '受检者' }]
                }
              ]
            },
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '样本编号' }]
                }
              ]
            },
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '原始测序数量' }]
                }
              ]
            },
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: 'Q30' }]
                }
              ]
            },
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '比对率' }]
                }
              ]
            },
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '平均测序深度' }]
                }
              ]
            },
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '目标区域覆盖度' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '1X' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '10X' }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          const fastQc = row.fastQc ?? {}
          const metricsData = fastQc.metricsData ?? {}
          const rawReads = metricsData.rawReads ?? '-'
          const readsMappedPercent = metricsData.readsMappedPercent ?? '-'
          const pctData = (fastQc.barChartData ?? []) as any[]
          const x1 = pctData.find((i) => i.name === '1x')?.value
          const x10 = pctData.find((i) => i.name === '10x')?.value
          const x20 = pctData.find((i) => i.name === '20x')?.value

          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.patient?.patientName ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.name ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: row.sample?.fileSize
                          ? row.sample?.fileSize > 1000
                            ? `${(row.sample?.fileSize / 1024).toFixed(2)}G`
                            : `${row.sample?.fileSize}MB`
                          : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `-`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: rawReads
                          ? `${rawReads}(${readsMappedPercent})`
                          : `-`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.avgReadDepth ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x1 ? `${x1}` : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x10 ? `${x10}` : '-'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '检测方法及局限性说明'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '一．测序方法'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `采用全基因组测序（whole genome sequencing，WGS）对受检者基因组中的全部DNA序列进行检测，覆盖了几乎全部基因的外显子序列，内含子序列和基因间序列，，使用DNBSEQ-T7平台进行测序，获得~30倍的平均覆盖深度。`
                    }
                  ]
                },
                {
                  type: 'p3',
                  children: [
                    {
                      text: '二．局限性'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '1. 单份标本检测不能100%确定胚系还是体细胞变异，建议通过其它检测进一步确认是否是胚系变异。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '2. 本检测报告单仅对该份样品负责。如受检者存在下列情况：（1）近期受过异体输血；（2）近期接受过移植手术（包括细胞治疗）等，检测结果将受上述因素影响而导致误差。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '3. 检测结果仅提供基因与临床疾病之间可能的关联，以及受检者在遗传方面患某种疾病的风险高低，存在检出的基因变异不能完全解释临床症状或预测临床预后的可能性。建议结合患者病史和家族史综合判断或咨询相关临床遗传学医生。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '4. 我们对受检者相关信息和检测结果保密。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '5. 本次检测涉及高度重复或同源的基因组区域的检测及分析可能不准确。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '6. 人类基因组参考序列仅来源于有限个体，部分基因组区域还存在参考序列的误差和空白间隙，变异识别可能出现假阳性和假阴性。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '7. 检测技术的局限性以及目前对遗传病的认识水平，如未检出能够解释受检者临床表型的特定基因及致病变异位点（即阴性结果），也并不能完全排除受检者存在某种遗传病的可能性。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '8. 以上结论均为实验室检测数据，用于患者的辅助诊疗，仅供参考，不可以作为最终诊断结果。具体的诊治应以临床为主，建议向您的主治医生进行咨询。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '9. 因水灾、火灾、疫情、运输中断以及根据中国法律或一般商业惯例认作不可抗力的其他事件发生，可能导致接收或检测样本的损耗致使检测无法进行或出现结果延期交付等情况，本机构具有对检测报告结果的说明、解释的权利。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '10. 本检测报告只对您寄送的样本负责。本机构对本结果完全保密并会依法保护用戶隐私。本机构保留对上述结果的最终解释权，如果您有疑问，请在收到结果后的7个工作日内与我们联系。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '11. 检测结果数据解读规则参考美国医学遗传学和基因组学学院（American College of Medical Genetics andGenomics，ACMG）相关指南。变异致病性的判定依据现有的临床表型、文献报道和数据库及生物学信息学软件判定，受科学发展的阶段性限制。随着时间推移，我们会获得更多关于这些基因的信息，我们的解读结果有可能会发生变化。变异命名参照HGVS建议的规则给出（http://www.hgvs.org/mutnomen/）。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '12. 随着时间推移，我们会获得更多关于这些基因的信息，我们的解读结果有可能会发生变化。变异命名参照HGVS建议的规则给出（http://www.hgvs.org/mutnomen/）。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p7',
      children: [
        {
          type: 'paragraph',
          text: ''
        }
      ]
    },
    {
      type: 'paragraph',
      text: '附录：'
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '线粒体全基因分析位点明细'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '位点'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '疾病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性分析'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '位点'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '疾病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性分析'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...MT_Site_Detail.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.gene1
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-omim',
                    children: [
                      {
                        text: row.omim1
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.acmg1
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.gene2
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-omim',
                    children: [
                      {
                        text: row.omim2
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-gene',
                    children: [
                      {
                        text: row.acmg2
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'paragraph',
      text: ''
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '检测变异列表'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'Chr'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'Begin'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'End'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'Ref'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'Obs'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'ref/alt(fre%)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性分析'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...detectionMTVariationList.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `Chr${row.chrom}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `${row.pos ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `${row.pos ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.REF || row.ref ? row.REF || row.ref : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.ALT || row.alt ? row.ALT || row.alt : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-gene',
                    children: [
                      {
                        text: `${row.coverage}[${(
                          row.allele_frequency * 100
                        ).toFixed(2)}]`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-gene',
                    children: [
                      {
                        text: row.user_acmg_classification
                          ? row.user_acmg_classification
                          : row.ACMG_classification
                          ? row.ACMG_classification
                          : row.classification
                          ? row.classification
                          : '-'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
